import React, { useState } from "react";
import {
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { dynamicImage } from "../../../../../../Utils";
import { Image, P } from "../../../../../../AbstractElements";
import {
  getAPIURLAWS,
  getSmartUser,
  getUserID,
} from "../../../../../../services/helper";
import http from "../../../../../../services/http";
import { toast } from "react-toastify";
import { newGroupAdded } from "../../../../../../ReduxToolkit/Reducers/ChatReducer";

const api_url_aws = getAPIURLAWS();
const current_user_id = getUserID();

export default function CreateNewGroupModal({ isOpen, toggle }) {
  const { members } = useSelector((state) => state.chat);
  const [groupName, setGroupName] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();

  const handleUserSelection = (userId) => {
    if (selectedUsers.some((user) => user.id === userId)) {
      setSelectedUsers(selectedUsers.filter((user) => user.id !== userId));
    } else {
      const userToAdd = members.find((member) => member.id === userId);
      if (userToAdd) {
        setSelectedUsers([...selectedUsers, userToAdd]);
      }
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleGroupNameChange = (e) => {
    setGroupName(e.target.value);
  };

  const filteredMembers = members.filter((member) =>
    member.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleGroupAdd = async () => {
    try {
      const users = [
        ...selectedUsers,
        filteredMembers.find((f) => f.id === Number(current_user_id)),
      ];
      const payload = {
        groupName,
        users,
        createdBy: getSmartUser(),
      };
      const { data: resp } = await http.post(
        `${api_url_aws}/chats/groups`,
        payload
      );
      if (resp.success) {
        toast.success("Group created successfully");
        dispatch(newGroupAdded(resp.data));
      }
      toggle();
    } catch (e) {
      console.error("Error while creating group", e);
      toggle();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Create New Group</ModalHeader>
      <ModalBody>
        <div className="group-name-container mb-4">
          <Input
            type="text"
            placeholder="Group Name"
            value={groupName}
            onChange={handleGroupNameChange}
            className="group-name-input"
          />
          <Button
            color="primary"
            className="add-group-button"
            onClick={handleGroupAdd}
            disabled={!groupName.trim() || selectedUsers.length === 0}
          >
            Add
          </Button>
        </div>

        <Input
          type="text"
          placeholder="Search members..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="mb-3"
        />
        <div className="members-grid">
          {filteredMembers.map((member) => (
            <div
              key={member.id}
              className={`member-item ${
                selectedUsers.some((user) => user.id === member.id)
                  ? "selected-member"
                  : ""
              }`}
              onClick={() => handleUserSelection(member.id)}
            >
              <Image
                className="img-fluid rounded-circle member-image"
                src={member.src ? member.src : dynamicImage("avtar/3.jpg")}
                alt="user"
              />
              <span className="member-name">{member.name}</span>
            </div>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleGroupAdd}
          disabled={!groupName.trim() || selectedUsers.length === 0}
        >
          Create
        </Button>{" "}
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
      <style jsx>{`
        .group-name-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .group-name-input {
          flex: 1;
          margin-right: 10px;
        }
        .members-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          justify-content: center;
        }
        .member-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 10px;
          cursor: pointer;
          background-color: white;
          border-radius: 8px;
          border: 1px solid #ccc;
          width: 120px;
          height: 120px;
        }
        .member-item.selected-member {
          background-color: #28a745;
          border-color: #28a745;
        }
        .member-image {
          width: 60px;
          height: 60px;
        }
        .member-name {
          margin-top: 5px;
          font-weight: 500;
          text-align: center;
        }
      `}</style>
    </Modal>
  );
}
